import {createDateFromFormat} from '../general/Utilities';
import { registrationOptions, categoriePJOptions } from '../../rca/search/searchOptions';

export const rcaRedirectStep  = (step) => {
    switch (step) {
        case 'auto':
            return '/asigurari-rca';
        case 'proprietar':
            return '/asigurari-rca/proprietar';
        case 'adresa':
            return '/asigurari-rca/adresa';
        case 'conducatori':
            return '/asigurari-rca/conducatori';
        case 'cerere':
            return '/asigurari-rca/cerere';
        case 'compara':
            return '/asigurari-rca/compara';
    }
}

export const carPlateNumber = (plate) =>{
    let regexStr = plate.match(/[a-z]+|[^a-z]+/gi);
    return regexStr.join('-');
}

export const VINMask = (vin) => {
    let pattern = '### ###### #### ####';
    let i = 0;
    let v = vin.toString();
    return pattern.replace(/#/g, ()=>v[i++]);
}

export const getCountyCodeFromCarPlate = (plate) => {
    let regexStr = plate.match(/[a-z]+|[^a-z]+/gi);
    return regexStr[0];
}

export const rcaMinStartDate = (tip_inmatriculare=null) => {
    let date = new Date();
    let delayDays = 1;
    if (tip_inmatriculare && tip_inmatriculare == 'in vederea inmatricularii') {
        delayDays = date.getDay() > 4 ? 9 - date.getDay() : 2;
    } else {
        let hour = date.getHours();
        if (hour>21) {
            delayDays = 2;
        } 
    }
   
    date.setDate(date.getDate() + delayDays);
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export const rcaMaxStartDate = () => {
    let date = new Date();
    date.setDate(date.getDate()+30);
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export const isDataPolitaValid = ( d ) => {
    const minDate = rcaMinStartDate();
    const maxDate = rcaMaxStartDate();
    return ((d>= minDate) && (d<=maxDate) ) ? true : false;
}

export const otherCountriesCarteVerde = [
    { name : 'Albania', abbr: 'AL'},
    { name : 'Azerbaidjan', abbr: 'AZ'},
    { name : 'Bosnia și Herțegovina', abbr: 'BIH'},
    { name : 'Belarus', abbr: 'BY'},
    { name : 'Iran', abbr: 'IR'},
    { name : 'Maroc', abbr: 'MA'},
    { name : 'Macedonia', abbr: 'MK'},
    { name : 'Marea Britanie', abbr: 'GB'},
    { name : 'Moldova', abbr: 'MD'},
    { name : 'Muntenegru', abbr: 'MNE'},
    { name : 'Rusia', abbr: 'RUS'},
    { name : 'Serbia', abbr: 'SRB'},
    { name : 'Tunisia', abbr: 'TN'},
    { name : 'Turcia', abbr: 'TR'},
    { name : 'Ucraina', abbr: 'UA'},
];

export const getCountryFromAbbr = (country) => {
    let find = otherCountriesCarteVerde.find( item => item.abbr == country);
    return find ? find : false; 
}

export const sortRCAList = (offers, termProp, field) => {
    offers.sort( (a, b) =>  a[termProp][field].prima - b[termProp][field].prima );
    return offers;
}

export const rcaExpirationDate  = (activeFrom) =>{
    //dd-mm-yyyy
    let startDate = createDateFromFormat(activeFrom);
    startDate.setHours(22, 0);
    let maxValid = new Date();
    maxValid.setDate(maxValid.getDate() + 13);
    maxValid.setHours(22, 0);
    return maxValid > startDate ? startDate : maxValid;
}

export const getRCAStatus = (status) => {
    
    switch( status) {
        case 'ON HOLD':
            return 'În așteptare documente';
            break;
        case 'RESERVED':
            return 'Ofertă rezervată';
            break;
        case 'READY':
            return 'În curs de emitere';
            break;
        case 'ISSUED':
            return 'Emisă';
            break;
        case 'NEW':
            return 'Oferta activa';
            break;
        case 'EXPIRED':
            return 'Oferta expirată';
            break;
    }
}

export const mapVehicleFromServer = (vehicle, resources, dataType) =>{
    const {car, owner, address, drivers, cerere} = vehicle;
    
    let newCar = {
        ...car,
        combustibil: resources.fuel,
        leasing_company_id: resources.hasOwnProperty('leasing')? resources.leasing: null,
        marca_auto: resources.marca,
        subcategorie_auto: resources.subcategorie,
        tip_inmatriculare: registrationOptions.find( item => item.value == car.tip_inmatriculare),
        leasing: car.leasing,
    }; 

    if (dataType == 'apiRequest') {
        newCar.leasing = car.leasing;
    } else {
        newCar.leasing = car.leasing ? 'da' : 'nu';
    }

    let newOwner;
    if (owner) {
        newOwner = {
            ...owner,
        };

        if (owner.tipClient == 'pj') {
            if (dataType == 'db') {
                newOwner.categorie_pj = categoriePJOptions.find( item => item.value == owner.categorie_pj);
                if (resources.hasOwnProperty('caen')) {
                    newOwner.caen = resources.caen;
                }
            } 
        }

        if (owner.tipClient == 'pj') {
            owner.caen = resources.caen;
        }
    }
    
    
    let newAddress;
    if (address) {
        newAddress = {
            ...address,
            Judet: resources.county,
            Localitate: resources.city,
        }
    }

    let newCerere = cerere ? {...cerere} : false;

    let newDrivers;
    if (dataType == 'apiRequest') {
        //date from previous api request
        newDrivers = drivers.map( driver => {
            return {
                nume: driver.nume,
                prenume: driver.prenume,
                cnp: driver.cnp,
                idserie: driver.idserie,
                idno: driver.idno,
                idtype: 'ci',
            }
        });

    } else {
        //data from db
        newDrivers = drivers ? drivers.map( driver => {
            return {
                nume: driver.Nume,
                prenume: driver.Prenume,
                cnp: driver.CNP,
                idserie: driver.serieCI,
                idno: driver.numarCI,
                idtype: 'ci',
            }
        }) : false;
    }
    
    return {
        car: newCar,
        owner: newOwner ? newOwner : false,
        address: newAddress ? newAddress : false,
        drivers: newDrivers,
        cerere: newCerere,
        serie_sasiu: car.serie_sasiu,
        step: false,
        active: false
    }

}

export const mergeUserVehicles = (stateVehicles, userVehicles) => {
    let newVehicles = [...stateVehicles];
    userVehicles.forEach( vehicle => {
        let findIndex = newVehicles.findIndex( item => item.serie_sasiu == vehicle.serie_sasiu);
      
        if (findIndex > -1) {
            let status = newVehicles[findIndex].active;
            let cerere = newVehicles[findIndex].cerere;
            newVehicles[findIndex] = {...vehicle, active: status, cerere};
        } else {
            newVehicles.push(vehicle);
        }
    });
    return newVehicles;
}

export const addVehicleToState = (stateVehicles, vehicle) =>{
    let findIndex = stateVehicles.findIndex( item => item.serie_sasiu == vehicle.serie_sasiu);
    let newVehicles = stateVehicles.map ( item => { return { ...item, active: false, step: false} } );
    let activeVehicle = {
        ...vehicle,
        active: true,
        step: 'compara',
    };

    if (findIndex > -1) {
        newVehicles[findIndex] = activeVehicle;
    } else {
        newVehicles.push(activeVehicle);
    }
    return newVehicles;
}


export const mapVehiclePriceCompareOld = (vehicle, resources) =>{
    const {car, owner, address, drivers, cerere} = vehicle;
    
    let newCar = {
        ...car,
        combustibil: resources.fuel,
        leasing_company_id: resources.hasOwnProperty('leasing')? resources.leasing: null,
        marca_auto: resources.marca,
        subcategorie_auto: resources.subcategorie,
        tip_inmatriculare: registrationOptions.find( item => item.value == car.tip_inmatriculare),
        leasing: car.leasing,
    };


    newCar.leasing = car.leasing;
  

    let newOwner = {
        ...owner,
    };

    let newAddress = {
        ...address,
        Judet: resources.county,
        Localitate: resources.city,
    }

    if (owner.tipClient == 'pj') {
        newOwner.caen = resources.caen;
        newOwner.categorie_pj = categoriePJOptions.find( item => item.value == owner.categorie_pj);
    }

    let newCerere = {
        dataPolita: cerere.dataPolita,
        durata: cerere.durata,
        countries: [],
    };

    let newDrivers = drivers.list.map( driver => {
            return {
                nume: driver.nume,
                prenume: driver.prenume,
                cnp: driver.cnp,
                idserie: driver.idserie,
                idno: driver.idno,
                idtype: 'ci',
            }
        });
    
    return {
        car: newCar,
        owner: newOwner,
        address: newAddress,
        drivers: newDrivers,
        cerere: newCerere,
        serie_sasiu: car.serie_sasiu,
        step: 'compara',
        active: true,
    }

}